import { useContext } from "react";

import { ThemeContext } from "components/ThemeContextProvider";

/** Hook to provide access to the current theme and toggle function
 * @returns { theme, toggleTheme }
 * @see ThemeContext
 */
export default function useTheme() {
    const { theme, toggleTheme } = useContext(ThemeContext);

    return { theme, toggleTheme };
}
